<template>
  <div>
    <form
      class="mb-16 grid flex-1 gap-16 overflow-hidden md:grid-cols-4 lg:grid-cols-6"
      @submit.prevent="submitFilters"
    >
      <RevInputSelect
        id="time-period"
        v-model="filtersValues.timeframe as Value"
        :label="i18n(translations.timeframe)"
        :options="timePeriodsOptions"
      />

      <RevInputSelect
        id="currency"
        v-model="filtersValues.currency as Value"
        :label="i18n(translations.currency)"
        :options="currenciesOptions"
      />
      <RevButton type="submit" variant="primary">
        {{ i18n(translations.applyFilters) }}
      </RevButton>
      <RevLink class="ml-16" type="button" @click="resetFilters">
        {{ i18n(translations.resetFilters) }}
      </RevLink>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import {
  type Option,
  RevInputSelect,
  type Value,
} from '@ds/components/InputSelect'
import { RevLink } from '@ds/components/Link'

import translations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

defineProps<{
  currenciesOptions: Option[]
  timePeriodsOptions: Option[]
  resetFilters: () => void
  submitFilters: () => void
}>()

const i18n = useI18n()
</script>
